import { isFedRamp } from '@atlassian/atl-context';
export function isMessagingEnabled() {
  return !isFedRamp();
}